import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'

import '../../css/user-table.css'

const StandardColumnTemplate = (rowData, field) => {
  return <div className={'click-column'}><span>{rowData[field]}</span> </div>
}

const UserTableFooter = ({ addUser }) => {
  return (
    <div className="p-helper-clearfix" style={{ width: '100%' }}>
      <Button icon="pi pi-plus" label="Add User" onClick={addUser} />
    </div>
  )
}

const UserTable = ({ users, selectUser, addUser, selectedUser }) => {
  let columnDefinitions = [
    { field: 'GivenNames', header: 'First Name', sortable: true, filter: true },
    { field: 'FamilyName', header: 'Last Name', sortable: true, filter: true },
    { field: 'Email', header: 'Email', sortable: true, filter: true },
    { field: 'Department', header: 'Department', sortable: true, filter: true },
  ]

  let columns = columnDefinitions.map(col => {
    return (<Column {...col} key={col.field} filterMatchMode="contains" 
    body={rowData => col.body ? col.body(rowData) : StandardColumnTemplate(rowData, col.field)} />)
  })
  let footer = <UserTableFooter addUser={addUser} />
  return (
    <DataTable value={users} footer={footer} selectionMode="single" selection={selectedUser} responsive={true}
      className="user-table" onRowClick={selectUser}>
      {columns}
    </DataTable>
  )
}

export default UserTable


// WEBPACK FOOTER //
// ./src/components/user/user-table.js